module.exports = __webpack_public_path__ + "static/media/textiles.f79840ef.png";